module.exports = __webpack_public_path__ + "media/images/shared/icon_facebook-d2485475edf097ec5ade2a9b7337e0f1.svg";